import clsx from 'clsx';
import React from 'react';

import { cn } from '@/src/util/ui';

const InputText = ({
  value,
  onInput,
  placeholder = '',
  className = '',
  containerClassName = '',
  endIcon = null,
  startIcon = null,
  ...otherProps
}) => {
  return (
    <div
      className={clsx(
        'tw-w-full tw-flex tw-items-center tw-gap-[5px] tw-px-[10px] tw-bg-cfo-grey-100 !tw-border tw-border-solid tw-border-cfo-grey-500 tw-rounded-[5px]',
        containerClassName
      )}
    >
      {startIcon}
      <input
        type="text"
        onInput={onInput}
        value={value}
        placeholder={placeholder}
        className={cn('tw-w-full tw-h-[32px] tw-py-[5px]', className)}
        {...otherProps}
      />
      {endIcon}
    </div>
  );
};

export default InputText;
